import { ClientAnalytics } from './clientAnalytics'

// ── Funnel entry (authed, owner) ──
type EntryEvent =
  | 'Achievement Share CTA Clicked'
  | 'Achievement Manage Page Viewed'

// ── Visibility & settings (authed, owner) ──
type ManageEvent =
  | 'Achievement Shared'
  | 'Achievement Hidden'
  | 'Achievement Settings Changed'
  | 'Achievement Share URL Copied'
  | 'Achievement Public Page Opened'

// ── Public page (anonymous or any viewer) ──
type PublicEvent = 'Public Achievement Viewed'

export type AchievementAnalyticsEvent = EntryEvent | ManageEvent | PublicEvent

export function trackAchievement(
  event: AchievementAnalyticsEvent,
  properties?: Record<string, unknown>
) {
  ClientAnalytics.track(event, properties)
}
